import { supabase } from "./supabaseClient";

export async function uploadTripDocument(
  file: File,
  tripId: string,
  name: string, // 👈 hier statt title
  userId: string,
  programItemId?: string
) {
  const fileExt = file.name.split(".").pop();
  const filePath = `${userId}/${Date.now()}.${fileExt}`;

  const { error: uploadError } = await supabase.storage
    .from("trip-documents")
    .upload(filePath, file);

  if (uploadError) {
    return { error: uploadError };
  }

  const { data, error } = await supabase
    .from("trip_documents")
    .insert({
      trip_id: tripId,
      creator_id: userId,
      program_item_id: programItemId || null,
      name, // 👈 hier statt title
      file_url: filePath, // 👈 hier statt file_path
    })
    .select();

  return { data, error };
}

export async function fetchTripDocuments(tripId: string) {
  const { data, error } = await supabase
    .from("trip_documents")
    .select("*")
    .eq("trip_id", tripId)
    .order("created_at", { ascending: false });

  return { data, error };
}

export async function getDocumentUrl(filePath: string) {
  const { data, error } = await supabase.storage
    .from("trip-documents")
    .createSignedUrl(filePath, 60 * 60); // gültig für 1 Stunde

  if (error) {
    console.error("Fehler beim Generieren der URL:", error.message);
    return null;
  }

  return data?.signedUrl || null;
}

export async function deleteTripDocument(id: string, filePath: string) {
  // 1. Datei aus dem Storage löschen
  const { error: storageError } = await supabase.storage
    .from("trip-documents")
    .remove([filePath]);

  if (storageError) {
    return { error: storageError };
  }

  // 2. Eintrag aus trip_documents löschen
  const { error: dbError } = await supabase
    .from("trip_documents")
    .delete()
    .eq("id", id);

  return { error: dbError };
}
